import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import _isNil from 'lodash/isNil';
/* eslint-disable react/no-unused-prop-types */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Search from '@wh/svg-icons/Search';
import X from '@wh/svg-icons/X';

import { getAllowedAttributes } from '../../props-filters';
import { isIphone5 } from '../../utils';
import './ActionArea.scss';

var makeExpandHandler = function makeExpandHandler(context) {
  return function () {
    if (_isNil(context.props.open)) {
      context.setState({ open: true });
    }
    if (!_isNil(context.props.onOpen)) {
      context.props.onOpen();
    }
  };
};

var makeCollapseHandler = function makeCollapseHandler(context) {
  return function () {
    if (_isNil(context.props.open)) {
      context.setState({ open: false });
    }
    if (!_isNil(context.props.onClose)) {
      context.props.onClose();
    }
  };
};

var ActionArea = function (_PureComponent) {
  _inherits(ActionArea, _PureComponent);

  function ActionArea() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ActionArea);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ActionArea.__proto__ || _Object$getPrototypeOf(ActionArea)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      open: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ActionArea, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$open = _props.open,
          open = _props$open === undefined ? this.state.open : _props$open,
          scrollable = _props.scrollable,
          mobile = _props.mobile,
          actions = _props.actions,
          children = _props.children,
          restProps = _objectWithoutProperties(_props, ['open', 'scrollable', 'mobile', 'actions', 'children']);

      return React.createElement(
        'div',
        _extends({
          className: cx('sb-action-area', { 'sb-action-area--scrollable': scrollable })
        }, getAllowedAttributes(restProps)),
        !open && React.createElement(
          'div',
          {
            className: cx('sb-header__section', 'sb-header__section--align-right', {
              'sb-header__section--scrollable': scrollable,
              'sb-header__section--scrollable-on-iphone5': scrollable && isIphone5()
            }),
            'data-test-id': 'header.slot-actions'
          },
          actions.map(function (button, key) {
            return React.createElement(
              'div',
              { key: key, className: 'sb-header__item' },
              button
            );
          })
        ),
        children && React.createElement(
          'div',
          { className: 'sb-header__section' },
          React.createElement(
            'div',
            {
              className: cx('sb-std-search', {
                'sb-std-search--open': open,
                'sb-std-search--mobile': mobile
              }),
              'data-test-id': 'search'
            },
            React.createElement(
              'button',
              {
                className: cx('sb-std-search__glass', {
                  'sb-std-search__glass--disabled': open
                }),
                onClick: makeExpandHandler(this),
                disabled: open,
                'data-test-id': 'search.open'
              },
              React.createElement(Search, null)
            ),
            open && [React.createElement(
              'button',
              {
                key: 'close',
                className: 'sb-std-search__cross',
                onClick: makeCollapseHandler(this),
                'data-test-id': 'search.close'
              },
              React.createElement(X, null)
            ), React.createElement(
              'div',
              { key: 'input', className: 'sb-std-search__input', 'data-test-id': 'search.content' },
              children
            )]
          )
        )
      );
    }
  }, {
    key: 'open',
    get: function get() {
      var isControlledMode = !_isNil(this.props.open);
      return isControlledMode ? this.props.open : this.state.open;
    },
    set: function set(value) {
      if (_isNil(this.props.open)) this.setState({ open: value });
    }
  }]);

  return ActionArea;
}(PureComponent);

ActionArea.propTypes = {
  mobile: PropTypes.bool,
  scrollable: PropTypes.bool,
  children: PropTypes.node,
  actions: PropTypes.arrayOf(PropTypes.node),
  open: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func
};
ActionArea.defaultProps = {
  actions: [],
  mobile: false
};
export default ActionArea;
//# sourceMappingURL=ActionArea.js.map